import React, {useContext} from 'react';
import Indicator from './Indicator';
import { createPortal } from 'react-dom';
import { observer } from 'mobx-react';
import usePortalDom from '../hooks/usePortalDom';
import {PageContext} from '../ComponentNavigatorV2/PageContext';
import { useGalleryInstance } from '../GalleryList/GalleryInstanceContext';

interface AllForIndicator {
  visible?: boolean;
}
const AllForIndicator = observer(function AllForIndicator(props: AllForIndicator) {
  const instanceStore = useGalleryInstance();
  
  const { total, mode, list} = instanceStore;
  const context = useContext(PageContext);
  const wrapper = usePortalDom({
    parentElement:window.document.getElementById(`page-top-${context.cid}`)! as HTMLDivElement
  });

  if (props.visible === false) return null;

  return wrapper ? createPortal(
    <Indicator
      total={total}
      mode={mode}
      loadedTotal={list.length}
    />,
    wrapper
  ) : null;
});

export default AllForIndicator;
